import { render, staticRenderFns } from "./FBA.vue?vue&type=template&id=55b65166&scoped=true&"
import script from "./FBA.vue?vue&type=script&lang=js&"
export * from "./FBA.vue?vue&type=script&lang=js&"
import style0 from "./FBA.vue?vue&type=style&index=0&id=55b65166&prod&scoped=true&lang=css&"
import style1 from "./FBA.vue?vue&type=style&index=1&id=55b65166&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b65166",
  null
  
)

export default component.exports